/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData(value) {
    if (!('SkuId' in value) || value['SkuId'] === undefined)
        return false;
    if (!('ItemName' in value) || value['ItemName'] === undefined)
        return false;
    if (!('SkuUnitPrice' in value) || value['SkuUnitPrice'] === undefined)
        return false;
    if (!('SkuImageURL' in value) || value['SkuImageURL'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SkuId': json['SkuId'],
        'ItemName': json['ItemName'],
        'SkuUnitPrice': json['SkuUnitPrice'],
        'SkuImageURL': json['SkuImageURL'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SkuId': value['SkuId'],
        'ItemName': value['ItemName'],
        'SkuUnitPrice': value['SkuUnitPrice'],
        'SkuImageURL': value['SkuImageURL'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData.js.map